import { DraggableLocation } from "@hello-pangea/dnd";
import { Menu, MenuItem } from "@mui/material";
import { HiddenChip } from "components/Layout";
import { useCallback } from "react";
import { IDraggableAlignmentResultSection, IResource, ISectionGroup, SectionGroup } from "store/types";
import { styled } from "styled-components";

interface IProps {
  state: any;
  anchor: any;
  onClose: () => any;
  onMove: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExclude?: (source: DraggableLocation, draggableId: string[]) => any;
  section: IDraggableAlignmentResultSection;
  resource: IResource;
}

const StyledMenuItem = styled(MenuItem)`
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  color: #252525;
`;

const StyledRedMenuItem = styled(StyledMenuItem)`
  color: #e2221b;
`;

export const ResourceMoveMenu = ({ state, anchor, onClose, onMove, onExclude, section, resource }: IProps) => {
  const onClick = useCallback(
    (destinationSection: IDraggableAlignmentResultSection) => {
      const source = {
        droppableId: section.uid,
        index: section.resourceIds.findIndex((uid: string) => uid === resource.uid),
      } as DraggableLocation;
      const destination = {
        droppableId: destinationSection.uid,
        index: destinationSection.resourceIds.length,
      } as DraggableLocation;
      onMove(source, destination, [resource.uid]);
      onClose();
    },
    [onClose, section.resourceIds, section.uid, onMove, resource.uid],
  );

  const onExcludeClick = useCallback(() => {
    const source = {
      droppableId: section.uid,
      index: section.resourceIds.findIndex((uid: string) => uid === resource.uid),
    } as DraggableLocation;
    onExclude && onExclude(source, [resource.uid]);
    onClose();
  }, [onClose, onExclude, resource.uid, section.resourceIds, section.uid]);

  return (
    <Menu
      anchorEl={anchor}
      id="move-menu"
      open={Boolean(anchor)}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      {state.sectionGroups
        .filter((sectionGroup: ISectionGroup) => sectionGroup.name !== SectionGroup.EXCLUDED)
        .map((sectionGroup: ISectionGroup) => {
          return sectionGroup.sections
            .filter((s: IDraggableAlignmentResultSection) => s.uid !== section.uid)
            .map((s: IDraggableAlignmentResultSection, index, { length }) => {
              return (
                <StyledMenuItem key={index} divider={index == length - 1} onClick={() => onClick(s)}>
                  {s.name}&nbsp;&nbsp;
                  {!s.visible && <HiddenChip label="Hidden" />}
                </StyledMenuItem>
              );
            });
        })}
      {onExclude && (
        <StyledRedMenuItem key={"excluded"} onClick={onExcludeClick}>
          Exclude
        </StyledRedMenuItem>
      )}
    </Menu>
  );
};
